import { connect } from 'react-redux'
import { checkXuJia } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    checkXuJia
}
const mapStateToProps = (state) => {
  return {
    ...state.XuJiaCheck
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
